import {gsap} from 'gsap'

export type AnimationElement = {
  element: Element
  animationType?: 'default' | 'asset'
}

// Animation functions that can be called with any elements
export const animateFadeIn = (animationElements: AnimationElement[], content: Element) => {
  if (animationElements.length > 0 && content) {
    // Detect if `motion reduced` is enabled
    const isMotionReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (!isMotionReduced) {
      // Set initial state for each element based on animation type
      for (const {element, animationType = 'default'} of animationElements) {
        if (animationType === 'asset') {
          const item = element.querySelector('[data-animate="item"]')
          const cover = element.querySelector('[data-animate="cover"]')
          if (item) gsap.set(item, {scale: 1.1})
          if (cover) gsap.set(cover, {opacity: 1})
        } else {
          gsap.set(element, {opacity: 0, y: 12})
        }
      }

      // Animate the elements when they are in view
      const observer = new IntersectionObserver(
        entries => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              const tl = gsap.timeline({delay: 0.1})

              // Animate each element with stagger
              for (const [index, {element, animationType = 'default'}] of animationElements.entries()) {
                const delay = index * 0.2 // Manual stagger calculation

                // Media assets animation ------------------
                if (animationType === 'asset') {
                  const item = element.querySelector('[data-animate="item"]')
                  const cover = element.querySelector('[data-animate="cover"]')

                  // Zoom out item
                  if (item) {
                    tl.to(
                      item,
                      {
                        scale: 1,
                        duration: 1.6,
                        ease: `expo.out`,
                      },
                      delay,
                    )
                  }

                  // Unblur cover
                  if (cover) {
                    tl.to(
                      cover,
                      {
                        scaleX: 0,
                        opacity: 0,
                        duration: 0.8,
                        ease: `Power2.easeInOut`,
                      },
                      delay,
                    )
                  }

                  // Default animation ------------------
                } else {
                  // Slide up
                  tl.to(
                    element,
                    {
                      y: 0,
                      duration: 1,
                      ease: `expo.out`,
                    },
                    delay,
                  )

                  // Fade in
                  tl.to(
                    element,
                    {
                      opacity: 1,
                      duration: 0.2,
                    },
                    delay,
                  )
                }
              }

              observer.unobserve(entry.target) // Stop observing after animation
            }
          }
        },
        {threshold: 0.5},
      )
      observer.observe(content)

      return () => {
        observer.disconnect()
      }
    }
  }

  return () => {}
}
